import React from 'react';

const About = ({ about }) => {
    return (
        <div className="about">
            {/* About Designer and documentarist filmmaker. With several
            award-winning companies and projects at festivals like London
            Festival, FITC & others. ᏌPAE is his music project with two music's
            launched. */}
            {about}
        </div>
    );
};

export default About;
